import { PropertyInformationPopoverContentUI } from './PropertyInformationPopoverContentUI';
import { useContext, useState, useEffect } from 'react';
import SegmentationFiltersSharedContext from '../../state/SegmentationFiltersSharedContext';
import DSFieldRecord from '../../filterQueryFormat/DSFieldRecord/DSFieldRecord';
import { useStrategy } from '../../hooks/useStrategy';
import { getPropertySettingsLink } from '../../api/propertySettingsUILinks';
import { useAwaitedState } from '../../hooks/useAwaitedState';
import PropertyInformationPopoverError from './PropertyInformationPopoverError';
import { jsx as _jsx } from "react/jsx-runtime";
export const PropertyInformationPopoverContent = ({
  filterFamily,
  propertyName
}) => {
  var _usagesResult$value, _getPropertySettingsL, _getPropertySettingsL2;
  const {
    getPropertyUsagesCached,
    getIsUngated
  } = useContext(SegmentationFiltersSharedContext);
  const {
    getField,
    isMagicField
  } = useStrategy();
  const [propertyInfo, setPropertyInfo] = useState();
  useEffect(() => {
    const loadPropertyInfo = async () => {
      try {
        const field = await getField(filterFamily, propertyName);
        setPropertyInfo(field);
      } catch (error) {
        console.error('Error loading property info:', error);
      }
    };
    void loadPropertyInfo();
  }, [filterFamily, getField, propertyName]);
  const usagesResult = useAwaitedState(getPropertyUsagesCached(filterFamily));
  if (!propertyInfo && usagesResult.state === 'rejected') {
    return /*#__PURE__*/_jsx(PropertyInformationPopoverError, {});
  }
  const isVirtualField = isMagicField === null || isMagicField === void 0 ? void 0 : isMagicField(propertyName, filterFamily, getIsUngated);
  const usageCount = usagesResult.state === 'fulfilled' && !isVirtualField ? (_usagesResult$value = usagesResult.value[`${filterFamily}/${propertyName}`]) !== null && _usagesResult$value !== void 0 ? _usagesResult$value : 0 : undefined;
  const field = DSFieldRecord.isDSFieldRecord(propertyInfo) ? propertyInfo : undefined;
  return /*#__PURE__*/_jsx(PropertyInformationPopoverContentUI, {
    loading: usagesResult.state === 'pending',
    label: field === null || field === void 0 ? void 0 : field.label,
    description: field === null || field === void 0 ? void 0 : field.description,
    fieldType: field === null || field === void 0 ? void 0 : field.fieldType,
    usageCount: usageCount,
    editLink: !isVirtualField ? (_getPropertySettingsL = getPropertySettingsLink(filterFamily, propertyName, 'edit')) !== null && _getPropertySettingsL !== void 0 ? _getPropertySettingsL : undefined : undefined,
    usagesLink: !isVirtualField ? (_getPropertySettingsL2 = getPropertySettingsLink(filterFamily, propertyName, 'usage')) !== null && _getPropertySettingsL2 !== void 0 ? _getPropertySettingsL2 : undefined : undefined
  });
};